import { getQueryParamValue } from "@chatfood/core-utils";
import { useLocalStorage } from "@chatfood/design-system";
import { useNavigation } from "../use-navigation";

export function useAppURI() {
  const { setItem, getItem, removeItem } = useLocalStorage();
  const { route } = useNavigation();

  const queryStringKey = "app-uri";
  const localStorageKey = `oo:${queryStringKey}`;
  const callbackQueryStringKey = "url";

  const persist = () => {
    const appURI = getQueryParamValue(route.value.query, queryStringKey);

    if (appURI) {
      setItem<string>(localStorageKey, decodeURIComponent(appURI));
    }
  };

  const retrieve = () => {
    return getItem<string>(localStorageKey);
  };

  const retrieveCallbackURI = (url: string): URL | undefined => {
    const appURI = retrieve();

    if (!appURI) return;

    const callbackURI = new URL(appURI);
    callbackURI.searchParams.set(
      callbackQueryStringKey,
      decodeURIComponent(url),
    );

    return callbackURI;
  };

  const reset = () => {
    removeItem(localStorageKey);
  };

  return {
    localStorageKey,
    queryStringKey,
    callbackQueryStringKey,
    retrieveCallbackURI,
    persist,
    retrieve,
    reset,
  };
}
